import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import PostCard from '../../news-feed/components/PostCard';

const PostsTab = ({ posts }) => {
  if (posts?.length === 0) {
    return (
      <div className="bg-card rounded-lg shadow-elevation-1 p-8 text-center">
        <Icon name="FileText" size={48} className="mx-auto text-muted-foreground mb-4" />
        <h3 className="text-lg font-medium text-foreground mb-2">No posts yet</h3>
        <p className="text-muted-foreground">When posts are shared, they'll appear here.</p>
      </div>);

  }

  return (
    <div className="space-y-4">
      {posts?.map((post) =>
        <PostCard key={post?.id} post={post} />
      )}
    </div>);

};

export default PostsTab;